// extracted by mini-css-extract-plugin
export var cell = "_54-4";
export var headerCell = "_54-2";
export var rowHeader = "_54-3";
export var table = "_54-1";
export var tableContainer = "_54-0";